module.exports = __webpack_public_path__ + "static/media/Icon_trash.9acb86b5.svg";